import { render } from "./NotFound.vue?vue&type=template&id=1571f32c&scoped=true"
import script from "./NotFound.vue?vue&type=script&setup=true&lang=js"
export * from "./NotFound.vue?vue&type=script&setup=true&lang=js"

import "./NotFound.vue?vue&type=style&index=0&id=1571f32c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1571f32c"],['__file',"src/errors/NotFound.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1571f32c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1571f32c', __exports__)) {
    api.reload('1571f32c', __exports__)
  }
  
  module.hot.accept("./NotFound.vue?vue&type=template&id=1571f32c&scoped=true", () => {
    api.rerender('1571f32c', render)
  })

}


export default __exports__